/**
 * town_names.ts — a settlement's NAME by its DB settlementId (site.id + 1), the maps' own table, memoised per
 * Commons seed (the federal docket's approach, shared by the town-life windows).
 */
import { atlas } from '../state.js';
import { settlementSites } from '../../../shared/settlements.js';
import { civilizationOf } from './biome_settlements.js';
import { settlementNamesFor } from './settlement_names.js';

let memo: { seed: string; names: Map<number, string> } | null = null;

export function commonsSeedNow(): string {
  const conn = atlas.conn;
  if (!conn) return '';
  for (const w of conn.db.world.iter()) if (w.kind === 'commons') return w.terrainSeed;
  return '';
}

export function townName(settlementId: unknown): string {
  const sid = Number(settlementId);
  const seed = commonsSeedNow();
  if (seed && (!memo || memo.seed !== seed)) {
    try { memo = { seed, names: settlementNamesFor(settlementSites(seed), (ss) => civilizationOf(ss)) }; } catch { memo = null; }
  }
  if (sid >= 1_000_000) return `player city ${sid - 1_000_000}`;
  return memo?.names.get(sid - 1) ?? `settlement ${sid}`;
}

/** Every town's (DB id, name, centre) — for a destination picker. Districts are left out (a capital is one town). */
export function townList(): Array<{ sid: number; name: string; x: number; z: number; tier: string }> {
  const seed = commonsSeedNow();
  if (!seed) return [];
  const out: Array<{ sid: number; name: string; x: number; z: number; tier: string }> = [];
  for (const s of settlementSites(seed)) {
    if (s.tier === 'district') continue;
    out.push({ sid: s.id + 1, name: townName(s.id + 1), x: s.centerX, z: s.centerZ, tier: s.tier });
  }
  return out;
}
